import * as React from 'react'
import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'

import { Notification, useNotifications } from 'modules/job_catalog/hooks/useNotifications'
import NotificationItem from 'modules/notifications/components/NotificationItem'

export const NewNotifications: React.FC = () => {
  const { notification } = useNotifications()
  const [pendingNotification, setPendingNotification] = React.useState<
    Notification | null | undefined
  >(null)

  useEffect(() => {
    setPendingNotification(notification)

    const timeout = setTimeout(() => {
      setPendingNotification(null)
    }, 10000)

    return () => clearTimeout(timeout)
  }, [notification])

  return (
    <AnimatePresence mode="wait">
      {pendingNotification && (
        <motion.div
          key={pendingNotification.id}
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            translate: '-50%',
            zIndex: '1000',
            cursor: 'pointer',
          }}
          initial={{ opacity: 0, translateY: '10%' }}
          animate={{ opacity: 1, translateY: '0' }}
          exit={{ opacity: 0, translateX: '10%' }}
        >
          <Box
            onClick={() => setPendingNotification(null)}
            background="grey000White"
            minWidth="s600"
            boxShadow="s300"
            border={{
              all: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{
              all: 'abs008',
            }}
          >
            <NotificationItem notification={pendingNotification}></NotificationItem>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
